const YesNoNode = require('../YesNoNode');
const TreeNode = require('../TreeNode');
const BattleCalc = require('../../BattleCalc');
const UseAbility = require('../UseAbility');

const Q_any_enemies = function (actor, battleState, moveTowardsTree) {
  const node = new YesNoNode(actor, battleState);

  if (BattleCalc.getEquippedAbility(actor, 'chain_pull')) {
    node.branches[node.YES] = new UseAbility(actor, 'chain_pull');
  } else {
    node.branches[node.YES] = moveTowardsTree;
  }
  node.branches[node.NO] = new TreeNode();

  node.yesNoEvalFunction = function () {
    return this.battleState.getEnemiesOfUnit(this.actor).length > 0;
  };

  return node;
};
module.exports = Q_any_enemies;
